import React from 'react';
import { seasonNames } from 'resources/common-values';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CommonValues from 'resources/common-values';
import CommonStrings from 'resources/common-strings';
import CreateReactClass from 'create-react-class';
import HelpBox from 'components/generic/help/index';
import RainbowChart from '../../rainbow-chart';
import NumberOrdinal from 'components/generic/number-ordinal';
import ComparisonUtils from '../../utils';
import NoPeriodDescription from '../../no-comparisons-period-message';

import rainbowHelpIcon from '../images/quintile-legend-sm.svg';
import rainbowHelpImg from '../images/quintile-legend.svg';

export default CreateReactClass({
    displayName: 'ComparisonsExpandedNormsPercentile',

    propTypes: {
        subjectBid: PropTypes.number.isRequired,
        studentBid: PropTypes.string.isRequired,
        growthPercentile: PropTypes.number,
        achievementPercentile: PropTypes.number,
        districtMedian: PropTypes.number,
        isUserNormData: PropTypes.bool,
    },

    renderNormsPercentiles(subjectName) {
        const growthDescription = this.props.growthPercentile
            ? ComparisonUtils.getMeanDescription(this.props.growthPercentile, true)
            : CommonStrings.comparisonsGrowthNoResult;
        const growthDescriptionClassName =
            growthDescription === CommonStrings.comparisonsGrowthNoResult
                ? 'no-score'
                : 'norms-percentile-expanded-description';

        const achievementDescription = this.props.achievementPercentile
            ? ComparisonUtils.getMeanDescription(this.props.achievementPercentile, true)
            : CommonStrings.comparisonsGrowthNoResult;
        const achievementDescriptionClassName =
            achievementDescription === CommonStrings.comparisonsGrowthNoResult
                ? 'no-score'
                : 'norms-percentile-expanded-description';

        return (
            <div
                className="growth-and-achievement-expanded"
                id={`comparisons-norms-percentiles-container-normal-${subjectName}-${this.props.studentBid}`}
                style={{ display: 'flex' }}
            >
                <div className="growth" style={{ width: '50%' }}>
                    <div
                        className="norms-percentile-category-expanded"
                        id={`comparisons-norms-percentiles-growth-heading-expanded-${subjectName}-${this.props.studentBid}`}
                    >
                        GROWTH
                    </div>
                    <div
                        className={growthDescriptionClassName}
                        id={`comparisons-${growthDescriptionClassName}-expanded-${subjectName}-${this.props.studentBid}`}
                    >
                        {growthDescription}
                    </div>
                    {this.props.growthPercentile ? (
                        <div
                            className="norms-percentile-value"
                            id={`comparisons-growth-percentile-value-expanded-${subjectName}-${this.props.studentBid}`}
                        >
                            <NumberOrdinal value={this.props.growthPercentile} upperCase={true} />
                        </div>
                    ) : (
                        <NoPeriodDescription
                            id={`comparisons-growth-no-periods-description-expanded-${subjectName}-${this.props.studentBid}`}
                            key="no-comparison-periods-message"
                            className="no-periods-description"
                        />
                    )}
                    <RainbowChart
                        key="comparisons-normal-growth-rainbow"
                        subjectBid={this.props.subjectBid}
                        studentBid={this.props.studentBid}
                        type="growth"
                        percentile={this.props.growthPercentile}
                        isExpanded={true}
                    />
                </div>
                <div className="achievement" style={{ width: '48%' }}>
                    <div
                        className="norms-percentile-category-expanded"
                        id={`comparisons-norms-percentiles-achievement-heading-expanded-${subjectName}-${this.props.studentBid}`}
                    >
                        ACHIEVEMENT
                    </div>
                    <div
                        className={achievementDescriptionClassName}
                        id={`comparisons-${achievementDescriptionClassName}-expanded-${subjectName}-${this.props.studentBid}`}
                    >
                        {achievementDescription}
                    </div>
                    {this.props.achievementPercentile ? (
                        <div
                            className="norms-percentile-value"
                            id={`comparisons-achievement-percentile-value-expanded-${subjectName}-${this.props.studentBid}`}
                        >
                            <NumberOrdinal value={this.props.achievementPercentile} upperCase={true} />
                        </div>
                    ) : (
                        <NoPeriodDescription
                            id={`comparisons-achievement-no-percentile-description-expanded-${subjectName}-${this.props.studentBid}`}
                            key="no-achievement-percentile-message"
                            className="no-achievement-description"
                            altMessageText={CommonStrings.noComparisonPeriodsMessage.altMessage}
                        />
                    )}
                    <RainbowChart
                        key="comparisons-normal-achievement-rainbow"
                        subjectBid={this.props.subjectBid}
                        studentBid={this.props.studentBid}
                        type="achievement"
                        percentile={this.props.achievementPercentile}
                        isExpanded={true}
                    />
                </div>
            </div>
        );
    },

    helpText() {
        return (
            <div className="comparisons-expanded-help-content" key="comparisons-expanded-help-content">
                <p key="initial-text">
                    {CommonStrings.normsPercentileHelp.initialText}
                    <b>{CommonStrings.normsPercentileHelp.growth} </b>
                    {CommonStrings.normsPercentileHelp.growthDescription}
                    <b>{CommonStrings.normsPercentileHelp.achievement} </b>
                    {CommonStrings.normsPercentileHelp.achievementDescription}
                </p>
            </div>
        );
    },

    rainbowHelpText() {
        return (
            <div
                className="comparisons-expanded-rainbow-bar-help-content"
                key="comparisons-expanded-rainbow-bar-help-content"
            >
                <p className="rainbow-bar-text" key="initial-text">
                    {CommonStrings.normsPercentileRainbowHelp.initialText}
                </p>
                <img className="rainbow-bar-image" src={rainbowHelpImg} />
            </div>
        );
    },

    render() {
        const normPercentileDisplay = this.props.isUserNormData
            ? CommonStrings.comparisonsGrowthAndAchievement.userNormPercentileHeader
            : CommonStrings.comparisonsGrowthAndAchievement.normPercentileHeader;
        const subjectName = CommonValues.getSubjectFieldforBid(this.props.subjectBid, 'shortName');
        return (
            <div
                className="growth-and-achievement-expanded-module norms-percentiles"
                id={`comparisons-growth-and-achievement-expanded-${subjectName}-${this.props.studentBid}-norms-percentile`}
                style={{ width: '40%' }}
            >
                <h3 className="comparisons-expanded-module-heading">
                    {normPercentileDisplay}
                    <HelpBox
                        id={`comparisons-expanded-help-box-norms-percentiles-${subjectName}-${this.props.studentBid}`}
                        appLevelCssClassName=""
                        helpContentsRenderer={this.helpText}
                        moduleName={CommonValues.SectionIDs.comparisons}
                        helpLabel="comparisons-view-norms-percentiles-help"
                    />
                    <HelpBox
                        id={`comparisons-expanded-help-box-rainbow-bar-${subjectName}-${this.props.studentBid}`}
                        appLevelCssClassName=""
                        helpContentsRenderer={this.rainbowHelpText}
                        moduleName={CommonValues.SectionIDs.comparisons}
                        helpLabel="comparisons-view-norms-percentiles-rainbow-bar-help"
                        renderIcon={false}
                        optionalImage={rainbowHelpIcon}
                    />
                </h3>
                {this.renderNormsPercentiles(subjectName)}
            </div>
        );
    },
});
